import React, {FunctionComponent} from "react";
import {graphql, useStaticQuery} from "gatsby"
import Layout from "./Layout";
import {LocalizedLink, useLocalization} from "gatsby-theme-i18n"
import useTranslateOrDefault from "../hooks/useTranslateOrDefault";

const doku = require("../images/dev-docs-icon.svg");
const usermanual = require("../images/ui-docs-icon.svg");
const download = require("../images/dl-docs-icon.svg");
const qsg = require("../images/qsg-docs-icon.svg");
const repo = require("../images/repo-docs-icon.svg");
const forum = require("../images/forum-docs-icon.svg");


type Props = {
    location: string[];
    slug: string;
    frontmatter?: any;
    delocalizedSlug: string;
};

type Tile = {
    image: string;
    url: string;
    name: string;
}

const Tiles: FunctionComponent<Props> = ({frontmatter, location, slug, delocalizedSlug}) => {
    const {locale} = useLocalization()

    const data = useStaticQuery(graphql`
        query {
          site {
            siteMetadata {
              quickstartUrl
              introductionUrl
              ecoSystemDownloadUrl
              ecoSystemRepoUrl
              userManualUrl
              forumUrl
            }
          }
        }
    `);

    const tiles: Tile[] = [
        {
            name: "qsg",
            url: data.site.siteMetadata.quickstartUrl,
            image: qsg,
        },
        {
            name: "usermanual",
            url: data.site.siteMetadata.userManualUrl,
            image: usermanual,
        },
        {
            name: "doku",
            url: data.site.siteMetadata.introductionUrl,
            image: doku,
        },
        {
            name: "repo",
            url: data.site.siteMetadata.ecoSystemRepoUrl,
            image: repo,
        },
        {
            name: "down",
            url: data.site.siteMetadata.ecoSystemDownloadUrl,
            image: download,
        },
        {
            name: "forum",
            url: data.site.siteMetadata.forumUrl,
            image: forum,
        }
    ];

    return (
        <Layout location={[]} navigationMarkdownEdges={[]} delocalizedSlug={delocalizedSlug}>
            <div className="start-content">
                {tiles.map(tile => {
                    const externalLink = !!tile.url.startsWith("https://")
                    const image = <div className="card-image">
                        <img src={tile.image}
                             alt={useTranslateOrDefault(`starting-page-alt-${tile.name}`, `${tile.name}`)}
                             className="tile-image"
                        />
                    </div>
                    const content = <div className="card-content">
                        <h3>{useTranslateOrDefault(`starting-page-headline-${tile.name}`, `${tile.name}`)}</h3>
                        <p>
                            {useTranslateOrDefault(`starting-page-text-${tile.name}`, `${tile.name}`)}
                        </p>
                    </div>
                    return (
                        <section className="card" key={`tile-${tile.name}`}>
                            {externalLink ?
                                <a href={tile.url}
                                   title={useTranslateOrDefault(`starting-page-title-${tile.name}`, `${tile.name}`)}>
                                    {image}
                                    {content}
                                </a>
                                :
                                <LocalizedLink to={tile.url} language={locale}
                                               title={useTranslateOrDefault(`starting-page-title-${tile.name}`, `${tile.name}`)}>
                                    {image}
                                    {content}
                                </LocalizedLink>
                            }
                        </section>
                    );
                })}
            </div>
        </Layout>
    );
}

export default Tiles;
